import bowser from 'yola-bowser';
import handleRemoveNextEmptyElement from '../helpers/handle-remove-next-empty-elements';
import handleRemoveImage from '../helpers/handle-remove-image';
import { DELETE_KEY } from '../constants/keys';
import view from '../../view';
import handleRemoveEmptyChildren from '../helpers/firefox-workarounds/handle-remove-empty-children';

const deleteHandler = (e) => {
  if (e.key !== DELETE_KEY) return;

  const selection = view.accessors.getSelection();

  if (selection.isCollapsed) {
    handleRemoveImage(e);
  } else {
    if (bowser.firefox) {
      handleRemoveEmptyChildren();
    }

    handleRemoveNextEmptyElement();
  }
};

export default deleteHandler;
